import { api, apiFile, apiPublic } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Setor from "model/administracao/cadastro/Setor";
import Usuario from "model/administracao/cadastro/Usuario";
import ClassificacaoRequisito from "model/auditoria5s/ClassificacaoRequisito";
import AcaoAuditoria from "model/auditoria5s/auditoria/AcaoAuditoria";
import Auditoria from "model/auditoria5s/auditoria/Auditoria";
import ComentarioAuditoria from "model/auditoria5s/auditoria/ComentarioAuditoria";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import SetorPlanoAuditoria from "model/auditoria5s/planoDeAuditoria/SetorPlanoAuditoria";
import { ChartBarModel } from "model/chart/ChartBarModel";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ExecucaoAuditoriaService implements BaseServiceCadastros<Auditoria> {
    pesquisar(page: Pageable, filter?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/auditoria/pesquisar/minhas`;
            if (filter) {
                url += getFilters(filter)
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: "numero,desc",
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Auditoria>((resolve, reject): void => {
            api
                .get(`/auditoria/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(auditoria: Auditoria) {
        return new Promise<Auditoria>((resolve, reject): void => {
            api
                .post(`/auditoria/incluir`, JSON.stringify(auditoria))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(auditoria: Auditoria) {
        return new Promise<Auditoria>((resolve, reject): void => {
            api
                .put(`/auditoria/editar`, JSON.stringify(auditoria))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/auditoria/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    iniciar(auditoria: Auditoria) {
        return new Promise<Auditoria>((resolve, reject): void => {
            api
                .post(`/auditoria/app/iniciar`, auditoria)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    finalizar(auditoria: Auditoria) {
        return new Promise<Auditoria>((resolve, reject): void => {
            api
                .post(`/auditoria/app/finalizar`, auditoria)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    cancelar(auditoria: Auditoria) {
        return new Promise<Auditoria>((resolve, reject): void => {
            api
                .post(`/auditoria/app/cancelar`, auditoria)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    salvarObservacao(auditoria: Auditoria) {
        return new Promise<Auditoria>((resolve, reject): void => {
            api
                .post(`/auditoria/app/salvarObservacao/${auditoria.id}`, {observacao: auditoria.observacao})
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    temOpcaoNaoAplicavel() {
        return new Promise<boolean>((resolve, reject): void => {
            api.get("/auditoria/app/temOpcaoNaoAplicavel")
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTotalPendentes(auditoria: Auditoria): number {

        let total = 0;

        if (auditoria.classesAuditoria) {
            for (let index = 0; index < auditoria.classesAuditoria.length; index++) {
                const classe = auditoria.classesAuditoria[index];
                if (classe.itensAuditoria) {
                    for (let index2 = 0; index2 < classe.itensAuditoria.length; index2++) {
                        const item = classe.itensAuditoria[index2];
                        if (item.status === 'CRIADO' || item.status === 'EM_ANDAMENTO') {
                            total++;
                        }
                    }
                }
            }
        }

        return total;
    }

    getTotalRealizados(auditoria: Auditoria): number {

        let total = 0;

        if (auditoria.classesAuditoria) {
            for (let index = 0; index < auditoria.classesAuditoria.length; index++) {
                const classe = auditoria.classesAuditoria[index];
                if (classe.itensAuditoria) {
                    for (let index2 = 0; index2 < classe.itensAuditoria.length; index2++) {
                        const item = classe.itensAuditoria[index2];
                        if (item.status === 'FINALIZADO') {
                            total++;
                        }
                    }
                }
            }
        }

        return total;
    }

    getUsuariosSetor(idSetor: number) {

        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/auditoria/app/setor/usuarios?setor=${idSetor}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    salvarAcao(acao: AcaoAuditoria) {

        return new Promise<AcaoAuditoria>((resolve, reject): void => {
            api
                .post(`/auditoria/app/acao`, JSON.stringify(acao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    apagarAcao(id: number) {

        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/acaoAuditoria/excluir/${id}`)
                .then(response => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTotalAcoesPendentes(item: ItemClasseAuditoria): number {

        let total = 0;

        if (item.acoesAuditoria) {
            for (let index = 0; index < item.acoesAuditoria.length; index++) {
                const acao = item.acoesAuditoria[index];
                if (acao.status === 'CRIADO' || acao.status === 'EM_ANDAMENTO') {
                    total++;
                }
            }
        }

        return total;
    }

    convertStatusAcaoString(status: string) {
        if (status === 'CRIADO') {
            return 'Criado';
        } else if (status === 'EM_ANDAMENTO') {
            return 'Em andamento';
        } else if (status === 'FINALIZADO') {
            return 'Finalizado';
        }
        return '';
    }

    salvarComentario(data: FormData) {

        return new Promise<ComentarioAuditoria>((resolve, reject): void => {
            apiFile
                .put(`/auditoria/app/comentario`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    apagarComentario(id: number) {

        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/comentarioAuditoria/excluir/${id}`)
                .then(response => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default ExecucaoAuditoriaService;
